import { render, staticRenderFns } from "./IconTile.vue?vue&type=template&id=2bd3c5dc&scoped=true&"
import script from "./IconTile.vue?vue&type=script&lang=js&"
export * from "./IconTile.vue?vue&type=script&lang=js&"
import style0 from "./IconTile.vue?vue&type=style&index=0&id=2bd3c5dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd3c5dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow,VSpacer})
